import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';

import * as errorUtils from '../../../modules/utility/global-utils';
import { CacheCountryService } from '../../../services/cacheCountries.service';
import { CountryApiService } from '../../petitioner/services/country.service';
import { LcaService } from '../../../services/lca.service';
import { ConfirmationService } from "primeng/api";

import { Store } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-attorney-agent-information',
  templateUrl: './attorney-agent-information.component.html',
  styleUrls: ['./attorney-agent-information.component.scss']
})
export class AttorneyAgentInformationComponent implements OnInit, OnChanges {

  @Input() attorneyInfoForm: FormGroup;
  @Input() companyInformation;

  @Output() change: EventEmitter<boolean> = new EventEmitter<boolean>();

  contactFormChangesSubscription: any;
  listCountry: any[];
  listStates: any[];
  listStatesHighest: any[];
  listLawFirm: any[];
  listAttorney: any[];
  panelOpenState: boolean = false;
  companyIdInfo;
  lawFirmId;
  userEfileInfo: any;
  userEfileInfoTemp: any;
  isDuplicateLCA: boolean = false;

  destroy$ = new Subject();
  
  constructor(private apiService: CountryApiService,
              private cacheCountryService: CacheCountryService,
              private confirmationService: ConfirmationService,
              private lcaApis: LcaService,
              protected store: Store<any>) {}

  ngOnChanges(changes: SimpleChanges){
    if(changes.companyInformation.currentValue){
      this.listLawFirm = [];
      this.listAttorney = [];
      this.companyIdInfo = changes.companyInformation.currentValue;
      this.attorneyInfoForm.patchValue({
        firmName: '',
        attorneyName: ''
      });
      this.resetAttorney();
      if(this.companyIdInfo){
        this.getLawFirmList();
        // this.setIsEmprReprAttorney();
      }
    } 
  }

  setIsEmprReprAttorney(){
    if(JSON.parse(localStorage.getItem('userEfileInfo'))){
      this.userEfileInfo = JSON.parse(localStorage.getItem('userEfileInfo'));
      if(this.userEfileInfo.lcaApplication.isEmprReprAttorney && this.userEfileInfo.attorneyOrAgentInfo.lcaCodeId){
        this.onChangeEnableAttorney(true);
      } else {
        this.onChangeEnableAttorney(false);
      }
    } else {
      this.onChangeEnableAttorney(false);
    }
  }

  ngOnInit(): void {
    this.cacheCountryService.getCachedCountryList()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data => {
      if (data.listCountries.length > 0) {
        this.listCountry = data.listCountries;
      }
    });
    this.onChangeHighesstCourt('USA');
    this.isDuplicateLCA = sessionStorage.getItem("isDuplicateLCA") === 'true';
  }

  opened() {
    this.change.emit(true);
  }

  getGlobalErrorMessages(error: string) {
    return errorUtils.errorMessages.get(error);
  }
  
  getLawFirmList(){
    const payload = {
      pageNo: 0,
      recordsPerpage: 0,
      searchCriteria:'',
      searchText: '',
      sortBy:''
    };
    this.lcaApis.getLawFirmList(this.companyIdInfo, payload)
    .pipe(takeUntil(this.destroy$))
    .subscribe(res => {
      if (res.data) {
        this.listLawFirm = res.data.attorneyDetailList;
        if(!this.listLawFirm.find(x => x.id === 'null')){
          this.listLawFirm.push({
            companyId: 'null',
            companyName: 'Other'
          });
        }
        if(this.listLawFirm.length>0){
          this.setIsEmprReprAttorney();
          this.onLoadMapping();
        }
      }
    });
  }

  onLoadMapping(){
    if(JSON.parse(localStorage.getItem('userEfileInfo'))){
      this.userEfileInfoTemp = JSON.parse(localStorage.getItem('userEfileInfo'));
      if(this.userEfileInfoTemp.lcaApplication.isEmprReprAttorney){
        if(this.userEfileInfoTemp.attorneyOrAgentInfo.company.companyId){
          this.attorneyInfoForm.patchValue({
            firmName: this.userEfileInfoTemp.attorneyOrAgentInfo.company.companyId
          });
          this.onChangeLawFirmName(this.userEfileInfoTemp.attorneyOrAgentInfo.company.companyId);
        } else {
          this.attorneyInfoForm.patchValue({
            firmName: 'null'
          });
          this.onChangeLawFirmName('null');
        }
      }
    } else {
      this.attorneyInfoForm.patchValue({	
        firmName: 'null'	
      });	
      this.onChangeLawFirmName('null');	
    }
  }

  onChangeLawFirmName(id){
    if(id !== 'null') {
      this.lawFirmId = id;
      this.listAttorney = [];
      this.attorneyInfoForm.patchValue({
        attorneyName: ''
      });
      this.resetAttorney();
      this.lcaApis.getEmployeesOfCompany(id)
      .pipe(takeUntil(this.destroy$))
      .subscribe(res => {
        if(res){
          this.listAttorney = res;
          this.listAttorney.map(item => item.userFullName = item.firstName + '\xa0' + item.lastName);
          if(JSON.parse(localStorage.getItem('userEfileInfo'))){
            this.userEfileInfoTemp = JSON.parse(localStorage.getItem('userEfileInfo'));
            if(this.userEfileInfoTemp.lcaApplication.isEmprReprAttorney){
              if(this.userEfileInfoTemp.attorneyOrAgentInfo.company.companyId === parseInt(id)){
                this.attorneyInfoForm.patchValue({
                  attorneyName: this.userEfileInfoTemp.attorneyOrAgentInfo.employee.id
                })
                this.onChangeAttorneyList(this.userEfileInfoTemp.attorneyOrAgentInfo.employee.id);
              } else if(this.userEfileInfoTemp.attorneyOrAgentInfo.company.companyId === 'null' && id === 'null'){
                this.attorneyInfoForm.patchValue({
                  attorneyName: null
                });
                this.onChangeAttorneyList('null');
              }
            }
          }
        }
      }); 
    } else{
      this.resetAttorney();
      this.listAttorney = [];
      this.listAttorney.push({
        id: 'null',
        userFullName: 'Other'
      });
      if(!this.listAttorney.find(x => x.id === 'null')){
        this.listAttorney.push({
          id: 'null',
          userFullName: 'Other'
        });
      }
      if(JSON.parse(localStorage.getItem('userEfileInfo'))){
        this.userEfileInfoTemp = JSON.parse(localStorage.getItem('userEfileInfo'));
        if(this.userEfileInfoTemp.lcaApplication.isEmprReprAttorney){
            if(this.userEfileInfoTemp.attorneyOrAgentInfo.employee.id === null){
              this.onChangeCountry(this.userEfileInfoTemp.attorneyOrAgentInfo.address.countryCode);
              this.attorneyInfoForm.patchValue({
                agentFirstName: this.userEfileInfoTemp.attorneyOrAgentInfo.firstName,
                agentMiddleName: this.userEfileInfoTemp.attorneyOrAgentInfo.middleName,
                agentLastName: this.userEfileInfoTemp.attorneyOrAgentInfo.lastName,
                emailId: this.userEfileInfoTemp.attorneyOrAgentInfo.email.mailId,
                telephone: this.userEfileInfoTemp.attorneyOrAgentInfo.phone.phoneNo,
                addressLine1: this.userEfileInfoTemp.attorneyOrAgentInfo.address.addressLine1,
                addressLine2: this.userEfileInfoTemp.attorneyOrAgentInfo.address.addressLine2,
                id: this.userEfileInfoTemp.attorneyOrAgentInfo.address.employee,
                country: this.userEfileInfoTemp.attorneyOrAgentInfo.address.countryCode,
                state: this.userEfileInfoTemp.attorneyOrAgentInfo.address.stateProvinceCode,
                city: this.userEfileInfoTemp.attorneyOrAgentInfo.address.city,
                postalCode: this.userEfileInfoTemp.attorneyOrAgentInfo.address.postalCode,
                stateProvinceName: this.userEfileInfoTemp.attorneyOrAgentInfo.address.stateProvinceName,
                extension: this.userEfileInfoTemp.attorneyOrAgentInfo.phone.phoneCode,
                firmFEIN: this.userEfileInfoTemp.attorneyOrAgentInfo.firmFEIN,
                LawFirmName: this.userEfileInfoTemp.attorneyOrAgentInfo.firmName,
                attorneyNameOfHighestStartCourt: this.userEfileInfoTemp.attorneyOrAgentInfo.attorneyNameOfHighestStartCourt,
                attorneyStateOfHighestCourt: this.userEfileInfoTemp.attorneyOrAgentInfo.attorneyStateOfHighestCourt,
                attorneyStateBarNo: this.userEfileInfoTemp.attorneyOrAgentInfo.attorneyStateBarNo,
                firmName: null,
                attorneyName: null
              });
            } else {
              this.resetAttorneyAgent();
            }
        } else {
          this.resetAttorneyAgent();
        }
      } else {
        this.listAttorney = [];	
        this.listAttorney.push({	
          id: 'null',	
          userFullName: 'Other'	
        });	
        if(!this.listAttorney.find(x => x.id === 'null')){	
          this.listAttorney.push({	
            id: 'null',	
            userFullName: 'Other'	
          });	
        }	
      }
      this.attorneyInfoForm.patchValue({
        companyId: 'null',
        employeeId: 'null',
        firmName: 'null',
        attorneyName: 'null',
        id: 'null'
      });
    }
  }

  onChangeEnableAttorney(value){
    if(value){
      this.attorneyInfoForm.patchValue({
        enableAttorney: value
      });
      this.attorneyInfoForm.controls.agentFirstName.setValidators([Validators.pattern('^[a-zA-Z ]*$'), Validators.required]);
      this.attorneyInfoForm.controls.agentLastName.setValidators([Validators.pattern('^[a-zA-Z ]*$'), Validators.required]);
      this.attorneyInfoForm.controls.addressLine1.setValidators([Validators.required]);
      this.attorneyInfoForm.controls.country.setValidators([Validators.required]);
      this.attorneyInfoForm.controls.state.setValidators([Validators.required]);
      this.attorneyInfoForm.controls.city.setValidators([Validators.required]);
      this.attorneyInfoForm.controls.postalCode.setValidators([Validators.required]);
      this.attorneyInfoForm.controls.telephone.setValidators([Validators.required]);
      this.attorneyInfoForm.controls.emailId.setValidators([Validators.pattern('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$'), Validators.required]);
      this.attorneyInfoForm.controls.LawFirmName.setValidators([Validators.required]);
      this.attorneyInfoForm.controls.attorneyStateBarNo.setValidators([Validators.required]);
      this.attorneyInfoForm.controls.attorneyStateOfHighestCourt.setValidators([Validators.required]);
      this.attorneyInfoForm.controls.attorneyNameOfHighestStartCourt.setValidators([Validators.required]);
      this.attorneyInfoForm.controls.firmName.setValidators([Validators.required]);
      this.attorneyInfoForm.controls.attorneyName.setValidators([Validators.required]);
    } else {
      this.attorneyInfoForm.reset();
      this.attorneyInfoForm.patchValue({
        enableAttorney: value
      });
      this.onChangeLawFirmName('null');
      this.attorneyInfoForm.controls.agentFirstName.setValidators([Validators.pattern('^[a-zA-Z ]*$')]);
      this.attorneyInfoForm.controls.agentLastName.setValidators([Validators.pattern('^[a-zA-Z ]*$')]);
      this.attorneyInfoForm.controls.addressLine1.clearValidators();
      this.attorneyInfoForm.controls.country.clearValidators();
      this.attorneyInfoForm.controls.state.clearValidators();
      this.attorneyInfoForm.controls.city.clearValidators();
      this.attorneyInfoForm.controls.postalCode.clearValidators();
      this.attorneyInfoForm.controls.telephone.clearValidators();
      this.attorneyInfoForm.controls.emailId.setValidators([Validators.pattern('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$')]);
      this.attorneyInfoForm.controls.LawFirmName.clearValidators();
      this.attorneyInfoForm.controls.attorneyStateBarNo.clearValidators();
      this.attorneyInfoForm.controls.attorneyStateOfHighestCourt.clearValidators();
      this.attorneyInfoForm.controls.attorneyNameOfHighestStartCourt.clearValidators();
      this.attorneyInfoForm.controls.firmName.clearValidators();
      this.attorneyInfoForm.controls.attorneyName.clearValidators();
    }
 
    this.attorneyInfoForm.controls.agentFirstName.updateValueAndValidity();
    this.attorneyInfoForm.controls.agentLastName.updateValueAndValidity();
    this.attorneyInfoForm.controls.addressLine1.updateValueAndValidity();
    this.attorneyInfoForm.controls.country.updateValueAndValidity();
    this.attorneyInfoForm.controls.state.updateValueAndValidity();
    this.attorneyInfoForm.controls.city.updateValueAndValidity();
    this.attorneyInfoForm.controls.postalCode.updateValueAndValidity();
    this.attorneyInfoForm.controls.telephone.updateValueAndValidity();
    this.attorneyInfoForm.controls.emailId.updateValueAndValidity();
    this.attorneyInfoForm.controls.LawFirmName.updateValueAndValidity();
    this.attorneyInfoForm.controls.attorneyStateBarNo.updateValueAndValidity();
    this.attorneyInfoForm.controls.attorneyStateOfHighestCourt.updateValueAndValidity();
    this.attorneyInfoForm.controls.attorneyNameOfHighestStartCourt.updateValueAndValidity();
    this.attorneyInfoForm.controls.firmName.updateValueAndValidity();
    this.attorneyInfoForm.controls.attorneyName.updateValueAndValidity();
  }

  onChangeAttorneyList(id){
    if(id !== 'null') {
      this.resetAttorney();
      let resData = this.listAttorney.find(x => x.id === parseInt(id));
      if(resData) {
        if(JSON.parse(localStorage.getItem('userEfileInfo'))){
          this.userEfileInfoTemp = JSON.parse(localStorage.getItem('userEfileInfo'));
          if(this.userEfileInfoTemp.lcaApplication.isEmprReprAttorney){
            if(this.userEfileInfoTemp.attorneyOrAgentInfo.company.companyId){
              if(this.userEfileInfoTemp.attorneyOrAgentInfo.employee.id === parseInt(id)){
                this.onChangeCountry(this.userEfileInfoTemp.attorneyOrAgentInfo.address.countryCode);
                this.attorneyInfoForm.patchValue({
                    agentFirstName: this.userEfileInfoTemp.attorneyOrAgentInfo.firstName,
                    agentMiddleName: this.userEfileInfoTemp.attorneyOrAgentInfo.middleName,
                    agentLastName: this.userEfileInfoTemp.attorneyOrAgentInfo.lastName,
                    emailId: this.userEfileInfoTemp.attorneyOrAgentInfo.email.mailId,
                    telephone: this.userEfileInfoTemp.attorneyOrAgentInfo.phone.phoneNo,
                    addressLine1: this.userEfileInfoTemp.attorneyOrAgentInfo.address.addressLine1,
                    addressLine2: this.userEfileInfoTemp.attorneyOrAgentInfo.address.addressLine2,
                    id: this.userEfileInfoTemp.attorneyOrAgentInfo.address.employee,
                    country: this.userEfileInfoTemp.attorneyOrAgentInfo.address.countryCode,
                    state: this.userEfileInfoTemp.attorneyOrAgentInfo.address.stateProvinceCode,
                    city: this.userEfileInfoTemp.attorneyOrAgentInfo.address.city,
                    postalCode: this.userEfileInfoTemp.attorneyOrAgentInfo.address.postalCode,
                    stateProvinceName: this.userEfileInfoTemp.attorneyOrAgentInfo.address.stateProvinceName,
                    extension: this.userEfileInfoTemp.attorneyOrAgentInfo.phone.phoneCode,
                    firmFEIN: this.userEfileInfoTemp.attorneyOrAgentInfo.firmFEIN,
                    LawFirmName: this.userEfileInfoTemp.attorneyOrAgentInfo.firmName,
                    attorneyNameOfHighestStartCourt: this.userEfileInfoTemp.attorneyOrAgentInfo.attorneyNameOfHighestStartCourt,
                    attorneyStateOfHighestCourt: this.userEfileInfoTemp.attorneyOrAgentInfo.attorneyStateOfHighestCourt,
                    attorneyStateBarNo: this.userEfileInfoTemp.attorneyOrAgentInfo.attorneyStateBarNo,
                });
              } else {
                this.mapAttorneyAgent(resData);
              }
            } else {
              this.mapAttorneyAgent(resData);
            }
          } else {
            this.mapAttorneyAgent(resData);
          }
        } else {
          this.mapAttorneyAgent(resData);
        }
      }
    } else{
      if(JSON.parse(localStorage.getItem('userEfileInfo'))){
        this.userEfileInfoTemp = JSON.parse(localStorage.getItem('userEfileInfo'));
        if(this.userEfileInfoTemp.lcaApplication.isEmprReprAttorney){
            if(this.userEfileInfoTemp.attorneyOrAgentInfo.employee.id === id){
              this.onChangeCountry(this.userEfileInfoTemp.attorneyOrAgentInfo.address.countryCode);
              this.attorneyInfoForm.patchValue({
                agentFirstName: this.userEfileInfoTemp.attorneyOrAgentInfo.firstName,
                agentMiddleName: this.userEfileInfoTemp.attorneyOrAgentInfo.middleName,
                agentLastName: this.userEfileInfoTemp.attorneyOrAgentInfo.lastName,
                emailId: this.userEfileInfoTemp.attorneyOrAgentInfo.email.mailId,
                telephone: this.userEfileInfoTemp.attorneyOrAgentInfo.phone.phoneNo,
                addressLine1: this.userEfileInfoTemp.attorneyOrAgentInfo.address.addressLine1,
                addressLine2: this.userEfileInfoTemp.attorneyOrAgentInfo.address.addressLine2,
                id: this.userEfileInfoTemp.attorneyOrAgentInfo.address.employee,
                country: this.userEfileInfoTemp.attorneyOrAgentInfo.address.countryCode,
                state: this.userEfileInfoTemp.attorneyOrAgentInfo.address.stateProvinceCode,
                city: this.userEfileInfoTemp.attorneyOrAgentInfo.address.city,
                postalCode: this.userEfileInfoTemp.attorneyOrAgentInfo.address.postalCode,
                stateProvinceName: this.userEfileInfoTemp.attorneyOrAgentInfo.address.stateProvinceName,
                extension: this.userEfileInfoTemp.attorneyOrAgentInfo.phone.phoneCode,
                firmFEIN: this.userEfileInfoTemp.attorneyOrAgentInfo.firmFEIN,
                LawFirmName: this.userEfileInfoTemp.attorneyOrAgentInfo.firmName,
                attorneyNameOfHighestStartCourt: this.userEfileInfoTemp.attorneyOrAgentInfo.attorneyNameOfHighestStartCourt,
                attorneyStateOfHighestCourt: this.userEfileInfoTemp.attorneyOrAgentInfo.attorneyStateOfHighestCourt,
                attorneyStateBarNo: this.userEfileInfoTemp.attorneyOrAgentInfo.attorneyStateBarNo,
              });
            } else {
              this.resetAttorneyAgent();
            }
        } else {
          this.resetAttorneyAgent();
        }
      } else {
        this.resetAttorneyAgent();
      }
    }
  }

  resetAttorneyAgent(){
    this.resetAttorney();
    this.attorneyInfoForm.patchValue({
      companyId: 'null',
      companyName: 'Other',
      employeeId: 'null'
    });
  }  

  mapAttorneyAgent(resData){
    this.attorneyInfoForm.patchValue({
      agentFirstName: resData.firstName,
      agentMiddleName: resData.middleName,
      agentLastName: resData.lastName,
      emailId: resData.email,
      telephone: resData.phone
    });
    this.lcaApis.getAttorneyCompanyList(this.lawFirmId).pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if(data) {
        this.onChangeCountry(data.address[0].countryCode.countryCode);
        this.attorneyInfoForm.patchValue({
          addressLine1: data.address[0].addressLine1,
          addressLine2: data.address[0].addressLine2,
          id: data.address[0].id,
          country: data.address[0].countryCode.countryCode,
          state: data.address[0].stateProvinceCode,
          city: data.address[0].city,
          postalCode: data.address[0].postCode,
          stateProvinceName: data.address[0].stateProvinceCode,
          extension: data.phoneContacts[0].extension,
          firmFEIN: data.feiNo
        });
      } 
    });
  }

  resetAttorney(){
    this.attorneyInfoForm.patchValue({
      agentFirstName: '',
      agentMiddleName: '',
      agentLastName: '',
      addressLine1: '',
      addressLine2: '',
      country: '',
      state: '',
      city: '',
      postalCode: '',
      stateProvinceName: '',
      extension: '',
      telephone: '',
      emailId: '',
      LawFirmName: '',
      firmFEIN: '',
      attorneyStateBarNo: '',
      attorneyStateOfHighestCourt: '',
      attorneyNameOfHighestStartCourt: ''
    });
  }

  onChangeCountry(countryCode: string) {
    console.warn('countryCode', countryCode);
    this.apiService.getStates(countryCode)
    .pipe(takeUntil(this.destroy$))
    .subscribe((states: []) => {
      this.listStates = states;
    });
  }

  onChangeHighesstCourt(countryCode: string) {
    this.apiService.getStates(countryCode)
    .pipe(takeUntil(this.destroy$))
    .subscribe((states: []) => {
      this.listStatesHighest = states;
    });
  }

  clearData() {
    // Clear any previous confirmation
    this.confirmationService.close();

    this.confirmationService.confirm({
      header: "Clear Data",
      icon: "pi pi-exclamation-triangle",
      rejectLabel: "Cancel",
      acceptLabel: "Yes, Clear Data",
      acceptButtonStyleClass: "btn-accept-clear",
      rejectButtonStyleClass: "btn-cancel-clear",
      message: `<div class="mb-4"> This will clear all the data from this section. </div>
                <div class="mb-4"> Are you sure, you want to clear data? </div>`,
      accept: () => {
        this.attorneyInfoForm.reset();
        this.confirmationService.close();
      },
      reject: () => {
         // Clear the confirmation dialog instance after rejection
        this.confirmationService.close();
      },
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
